module.exports = __webpack_public_path__ + "img/ddm3.cb23b255.png";